import { createSlice } from '@reduxjs/toolkit';
import appapi from '../../api/apiClient';
import { useSelector } from 'react-redux';

//Initial State of authslice
const initialState = {
  userId:null,
  user: null,
  companyDetails: null,
  userPermission: null,
  isLoggedIn: false,
  sideMenuList: null,
};

const authSlice = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    //Login
    login(state, action) {
      state.isLoggedIn = true;
      state.userId = action.payload;
    },
    //Logout
    logout(state) {
      // window.grecaptcha.reset();
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      state.isLoggedIn = false;
      state.userId = null;
      state.user = null;
      state.companyDetails = null;
    },
    setCompanyDetails(state, action) {
      state.companyDetails = action.payload;
    },
    setUserPermission(state, action) {
      state.userPermission = action.payload;
    },
    refreshUserData(state, action) {
      state.user = action.payload;
    },
    updateSideMenuList(state, action) {
      state.sideMenuList = action.payload;
    },
  },
});

/**
 * @function initUserData
 * @returns The updated logged In User Data
 */
export const initUserData = () => {
  return async (dispatch, getState) => {
    const { userId } = getState().auth;
    if (userId) {
      const response = await appapi.get(`/user/details`);
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(refreshUserData(data.response));
        }
      }
    }
  };
};

/**
 * @function initCompanyDetails
 * @returns The updated logged In User Data
 */
export const initCompanyDetails = () => {
  return async (dispatch, getState) => {
    const { userId } = getState().auth;
    if (userId) {
      const response = await appapi.get(`/admin-portal/organisation/${userId}`);
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setCompanyDetails(data.response));
        }
      }
    }
  };
};

export const checkPermission = (state, moduleName) => {
  const { userPermission } = state.auth;
  if (userPermission) {
    const module = userPermission[moduleName];
    if (module) {
      return {
        viewAccess: module.viewAccess === '1',
        editAccess: module.editAccess === '1',
        excelAccess: module.excelAccess === '1',
        blockAccess: module.blockAccess === '1',
      };
    }
  }
  return {
    viewAccess: false,
    editAccess: false,
    excelAccess: false,
    blockAccess: false,
  };
};

export const { login, logout, refreshUserData, updateSideMenuList, setUserPermission, setCompanyDetails } = authSlice.actions;
export default authSlice.reducer;
